<template>
    <button
        type="button"
        v-bind:class="[customClass, ga]"
        v-bind:disabled="disabled"
        v-on:click="!disabled && onClick()"
    >
        <slot>{{ title }}</slot>
    </button>
</template>

<script setup lang="ts">
    interface Props {
        title?: string;
        onClick: () => void;
        ga?: string;
        customClass?: string | string[];
        disabled?: boolean;
    }

    withDefaults(defineProps<Props>(), {
        title: '',
        ga: '',
        customClass: 'button _primary cta-w85',
        disabled: false,
    });
</script>
